import contourConfig from 'constants/contourConfig';
import applicationReducerFactory from 'modules/FieldsMap/partials/Applications/reduxState/applicationStateManagement/applicationReducerFactory';

const pgrApplicationFromGAIReducer = applicationReducerFactory(
  contourConfig.pgrApplicationFromGAI.name,
);

export default pgrApplicationFromGAIReducer;
